import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import "./index.scss";
import category from "../../../assets/images/category.png";
import cat1 from "../../../assets/images/cat1.png";
import cat2 from "../../../assets/images/cat2.png";
import cat3 from "../../../assets/images/cat3.png";
import { FleshIcon } from "../../../assets/icons/FleshIcon";
import { useNavigate } from "react-router-dom";
import CategoryService from "../../../services/category";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import ImageCategoryService from "../../../services/imageCategory";

const categoryService = new CategoryService();
const imageCategoryService = new ImageCategoryService();
const CategoriesSection = () => {
  const [categories, setCategories] = useState([]);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await categoryService.getAllCategories();
      // Filter out "nos packs" category
      const filteredCategories = res?.data?.filter(cat => 
        cat.title?.toLowerCase() !== "nos packs"
      ) || [];
      setCategories(filteredCategories);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
    setIsLoading(false);
  };
 

  useEffect(() => {
    loadData();
  }, []);
  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  function getImageURL(userId) {
    return `${apiUrl}/categories/${userId}/image`;
  }
  const getImageURL1 = (imageName) =>
    `${apiUrl}/image-category/68d17b3f9857f9a1f11152c2/image`;
  return (
    <div className="categories-section  my-5">
      <Row className="align-items-center">
        {/* Colonne gauche image */}
        <Col md={6} className="d-md-block d-none h-100">
          <img
            src={getImageURL1()}
            alt="Category showcase"
            className="h-100 left-image w-100"
          />
        </Col>

        {/* Colonne droite titre + cartes */}
        <Col md={6}>
          <h2 className="section-title">NOS CATEGORIES</h2>
          <Row className="mt-4 gy-3 gx-3">
            {categories.map((cat) => (
              <Col key={cat._id} md={4} sm={6} xs={12}>
                <div
                  className="category-card"
                  onClick={() => {
                    navigate(`all-products?category=${cat._id}`);
                    window.scrollTo(0, 0);
                  }}>
                  <div className="cat-title">
                    {cat.title} <FleshIcon />
                  </div>
                  <img variant="top" src={getImageURL(cat._id)} />
                </div>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default CategoriesSection;
